// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"4b84cc0e","163":"88648909","496":"4bea5648","599":"6e514864","600":"56fe6dc9","707":"ebdf0a5c","952":"9cd6f11a"}[chunkId] + ".chunk.css";
};